window._ = require('lodash');

window.$ = window.jQuery = require('jquery');
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

//require('bootstrap');
require('jquery-toast-plugin');
require('jquery-validation');
require('select2');
require('datatables.net-bs5');
window.Swal = require('sweetalert2');

// Import lightbox
import GLightbox from 'glightbox';
window.GLightbox = GLightbox;

import 'glightbox/dist/css/glightbox.min.css';

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';
window.axios = axios;

//window.axios.defaults.baseURL = window.location.protocol + '//' + window.location.hostname;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.withCredentials = true;

// Fetch the CSRF cookie from Sanctum so the XSRF-TOKEN cookie is set in the browser.
// Stored as a promise so request interceptors can await it before any request fires.
// .catch(() => {}) ensures it never rejects, so awaiting it is always safe.
window.csrfReady = axios.get('/sanctum/csrf-cookie').catch(() => {});

// Global interceptor — await the CSRF cookie before every request.
// Covers stores and API files that use raw axios (settings.js, schedules.js, auth.js, etc.)
// axios.create() instances (useApi.js) have their own identical interceptor.
// Note: the /sanctum/csrf-cookie call above is dispatched before this interceptor is
// registered, so it is never intercepted — no circular dependency.
axios.interceptors.request.use(async (config) => {
    await window.csrfReady;
    return config;
});

// Global 419 response interceptor — if the CSRF token is stale (e.g. after session expiry
// or logout), refresh the XSRF-TOKEN cookie and retry the original request once.
// This covers all stores that use raw axios directly (settings.js, schedules.js, auth.js).
axios.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (error.response?.status === 419 && !error.config._csrfRetry) {
            error.config._csrfRetry = true;
            window.csrfReady = axios.get('/sanctum/csrf-cookie').catch(() => {});
            await window.csrfReady;
            return axios(error.config);
        }
        return Promise.reject(error);
    }
);

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
window.Pusher = Pusher;

window.Echo = new Echo({
    broadcaster: 'reverb',
    key: process.env.MIX_REVERB_APP_KEY,
    wsHost: process.env.MIX_REVERB_HOST ?? window.location.hostname,
    wsPort: process.env.MIX_REVERB_PORT ?? 8080,
    wssPort: process.env.MIX_REVERB_PORT ?? 8080,
    forceTLS: (process.env.MIX_REVERB_SCHEME ?? 'http') === 'https',
    enabledTransports: ['ws', 'wss'],
    // Use axios for channel auth so CSRF token is included automatically
    authorizer: (channel) => {
        return {
            authorize: (socketId, callback) => {
                axios.post('/broadcasting/auth', {
                    socket_id: socketId,
                    channel_name: channel.name,
                })
                .then(response => callback(false, response.data))
                .catch(error => callback(true, error));
            },
        };
    },
});

// Register Service Worker (shared across admin, handyman, and SPA builds)
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js').catch(() => {});
    });
}

// Enable Bootstrap 5 popovers
document.addEventListener('DOMContentLoaded', function () {
    const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    const popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl);
    });
});
